import {
  ACCOUNT_ORDERS_PAGE,
  ACCOUNT_SETTINGS_PAGE,
  CART_PAGE,
  LOGIN_PAGE,
  MARKETS_PAGE,
  NEWS_AND_EVENTS_PAGE,
  PROFESSIONALS_PAGE,
  SHOP_PAGE,
  STORES_PAGE,
  TRY_AT_HOTEL_PAGE,
  WHY_DUX_PAGE
} from './page-links';

export const secondaryNavLinks = [
  {
    url: STORES_PAGE,
    title: 'Stores',
    label: 'stores',
    target: ''
  },
  {
    url: SHOP_PAGE,
    title: 'Shop',
    label: 'shop',
    target: ''
  },
  {
    url: MARKETS_PAGE,
    title: 'Markets',
    label: 'countries',
    target: ''
  },
  {
    url: '#',
    title: 'Search',
    label: 'search',
    target: ''
  },
  {
    url: LOGIN_PAGE,
    title: 'Login',
    label: 'profile',
    target: ''
  },
  {
    url: CART_PAGE,
    title: 'Cart',
    label: 'cart',
    target: ''
  }
];

export const accountMenuItems = [
  {
    title: 'Orders',
    url: ACCOUNT_ORDERS_PAGE
  },
  // {
  // 	title: "Messages",
  // 	url: ACCOUNT_MESSAGES_PAGE
  // },
  // {
  //   title: 'Communication Preferences',
  //   url: ACCOUNT_PREFERENCES_PAGE
  // },
  // {
  //   title: 'Wishlists',
  //   url: ACCOUNT_WISHLISTS_PAGE
  // },
  {
    title: 'Account Settings',
    url: ACCOUNT_SETTINGS_PAGE
  }
];

export const mobileMenuItems = {
  secondary: [
    {
      label: 'Stores',
      url: STORES_PAGE
    },
    {
      label: 'Shop',
      url: SHOP_PAGE
    },
    {
      label: 'Markets',
      url: MARKETS_PAGE
    },
    {
      label: 'Login',
      url: LOGIN_PAGE
    },
    {
      label: 'Cart',
      url: CART_PAGE
    }
  ]
};

export const searchListItems = [
  {
    label: 'Try at Hotel',
    url: TRY_AT_HOTEL_PAGE
  },
  {
    label: 'Stores',
    url: STORES_PAGE
  },
  {
    label: 'Professionals',
    url: PROFESSIONALS_PAGE
  },
  {
    label: 'Why Dux',
    url: WHY_DUX_PAGE
  },
  {
    label: 'News and Events',
    url: NEWS_AND_EVENTS_PAGE
  }
];
